import { ServiceModel } from 'types';
export class Service implements ServiceModel {
  id: string;
  data: object | undefined;

  constructor(id: string, data?: object) {
    this.id = id;
    this.data = data;
  }
}
